export type SupportedLanguagesType = ['en', 'de_DE', 'fr_FR', 'es_MX'];
export type SupportedLanguage = SupportedLanguagesType[number];
export const supportedLanguages: SupportedLanguagesType = ['en', 'de_DE', 'fr_FR', 'es_MX'];
